module.exports = __webpack_public_path__ + "static/logo-cf23185d38ac74348e6284cc8625b255.svg";